module.exports = __webpack_public_path__ + "static/img/iconfont.16edd84.svg";